<i18n>
    {
        "en": {
            "send": "SEND TOKEN",
            "resend": "Resend",
            "title": "One Step To Activate Your Account",
            "description": "in order to start using your peekage account, you need to confirm your email address.",
            "didNotYouGetTheEmail": "Didn’t you get the email?",
            "message": "The token has been sent to your email. Please check your inbox.",
            "form": {
                "code": {
                    "label": "Enter Code",
                    "placeholder": "Enter Code"
                },
                "email": {
                    "label": "Enter Email",
                    "placeholder": "Enter your email address"
                }
            }
        }
    }
</i18n>

<template>
    <auth-page class="page-register ">
        <template #container>
            <div class="form-container">
                <h2 class="text f-s-14 l-h-16 f-std-med mb-0">
                    {{ $t('title') }}
                </h2>
                <p class="text f-s-12 l-h-18 f-std-book max-w-268">
                    {{ $t('description') }}
                </p>
                <form class="my-3"
                      id="signIn-form"
                      @submit.prevent="login"
                      @keyup.enter="login"
                >
                    <div class="mb-4">
                        <input-text
                            :placeholder="$t('form.email.placeholder')"
                            :label="$t('form.email.label')"
                            :error="errors.first('username')"
                            v-validate="'required|email'"
                            v-model="form.username"
                            name="username"
                            autofocus
                            required
                            class="max-w-239"
                        />
                    </div>
                </form>

                <ech-button @click="resend"
                            class="btn-danger text-uppercase"
                            :text="$t('send')"
                            icon="icon plus"
                            :loading="loading"
                />
                <div>
                    <p class="text f-std-book f-s-12 mt-3">
                        {{ $t('didNotYouGetTheEmail') }}

                        <strong @click="resend" class="text f-std-black f-s-12 color black pointable">{{ $t('resend') }}</strong>
                    </p>
                </div>
            </div>
        </template>
    </auth-page>
</template>

<script>
import { mapActions } from 'vuex';
import get from 'lodash/get';
import widgetMarketerRequestOtp from '~/gql/mutations/widgetMarketerRequestOtp.gql';
import { showErrors } from '~/scripts/utils/index';
import mixin from '~/components/pages/auth/auth';

export default {
    mixins: [mixin],
    layout: 'blank',
    data () {
        return {
            loading: false,
            form: {
                username: '',
                type: 'recover_password',
            },
        };
    },
    head () {
        return {
            title: 'Peekage: Forget Password',
            meta: [
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex',
                },
            ],
        };
    },
    computed: {
        hasUsername () {
            return get(this.$route, 'query.username', false);
        },
    },
    methods: {
        ...mapActions(['showAlert']),
        async resend () {
            try {
                this.loading = true;

                const valid = await this.$validator.validateAll();
                if (!valid) {
                    this.showAlert(this.$t('errors.validation'));
                    return;
                }

                const { form } = this;
                await this.$apollo.mutate({
                    mutation: widgetMarketerRequestOtp,
                    variables: {
                        input: { ...form },
                    },
                });

                this.showAlert({
                    text: this.$t('message'),
                    type: 'info',
                });

                this.$router.push('/password/reset');

                return this.$router.push({
                    query: {
                        username: this.form.username,
                    },
                    path: '/password/reset',
                });
            } catch (error) {
                showErrors(error, this);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .max-w-268 {
        max-width: 268px;
    }

    .max-w-239 {
        max-width: 239px;
    }
</style>
